
// LIBS
import { TweenMax, TimelineLite, Power2, Elastic, CSSPlugin } from "gsap/TweenMax";

import tarteaucitronJs      from "./libs/tarteaucitronJs";
import swiperHome           from "./libs/swiperHome";
import swiperActu           from "./libs/swiperActu";
import swiperRea            from "./libs/swiperRea";
import swiperTexteImage     from "./libs/swiperTexteImage";
import swiperClient         from "./libs/swiperClient";
import menu                 from "./libs/menu";
import swiper2colImage      from "./libs/swiper2colImage";
import menuContent          from "./libs/menuContent";
import masonry              from "./libs/masonry";
import scrollAnimations     from "./libs/scrollAnimations";
import popupevent           from "./libs/popupevent";
import detectTouchDevice    from "./libs/detectTouchDevice";
import swiperMenuHome       from "./libs/swiperMenuHome";
import backTop              from "./libs/backTop";
import popupLogin           from "./libs/popupLogin";


console.log('welcome to app.js')
// Vérifier si jQuery est bien chargé
if (typeof jQuery === 'undefined') {
    console.error("Erreur : jQuery n'est pas chargé !");
}

// Init Js
$(document).ready(() => {
    detectTouchDevice.init();
    tarteaucitronJs.init();
    menu.init();
    scrollAnimations.init();
    popupevent.init();
    backTop.init();
    popupLogin.init();

    if ($('html').hasClass('no-touch')) {
        // customCursor.init();
    }

    if ($('body').hasClass('home')) {
        swiperHome.init();
        swiperActu.init();
        swiperRea.init();
        swiperTexteImage.init();
        swiperClient.init();
        swiperMenuHome.init();

        $(window).resize(function() {
            swiperHome.init();
            swiperActu.init();
            swiperRea.init();
            swiperTexteImage.init();
            swiperClient.init();
            swiperMenuHome.init();
        });
    }

    if ($('body').hasClass('page-template-flexiblecontent')) {
        swiperTexteImage.init();
        swiper2colImage.init();
        menuContent.init();

        $(window).resize(function() {
            swiperTexteImage.init();
            swiper2colImage.init();
        });
    }

    if ($('body').hasClass('page-template-flexiblecontentsommaire')) {
        swiperTexteImage.init();
        swiper2colImage.init();
        menuContent.init();

        $(window).resize(function() {
            swiperTexteImage.init();
            swiper2colImage.init();
        });
    }

    if ($('body').hasClass('single-equipe')) {
        swiperTexteImage.init();
        swiper2colImage.init();
        menuContent.init();

        $(window).resize(function() {
            swiperTexteImage.init();
            swiper2colImage.init();
        });
    }

    if ($('body').hasClass('single-realisation')) {
        swiperTexteImage.init();
        swiper2colImage.init();
        menuContent.init();

        $(window).resize(function() {
            swiperTexteImage.init();
            swiper2colImage.init();
        });
    }

    if ($('body').hasClass('page-template-ressources')) {
        masonry.init();

        $(window).resize(function() {
            masonry.init();
        });
    }

    if ($('body').hasClass('page-template-realisations')) {
        masonry.init();

        $(window).resize(function() {
            masonry.init();
        });
    }

    if ($('body').hasClass('page-template-sommaire')) {
        masonry.init();

        $(window).resize(function() {
            masonry.init();
        });
    }

    if ($('body').hasClass('page-template-equipe')) {
        masonry.init();

        $(window).resize(function() {
            masonry.init();
        });
    }
});
